/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    user_type?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserType;
    /**
     * 
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser(value: object): value is FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    return true;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'title': json['title'] == null ? undefined : json['title'],
        'user_type': json['user_type'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeFromJSON(json['user_type']),
        'photo_url': json['photo_url'] == null ? undefined : json['photo_url'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserToJSONTyped(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'title': value['title'],
        'user_type': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerUserUserTypeToJSON(value['user_type']),
        'photo_url': value['photo_url'],
    };
}

